module.exports = __webpack_public_path__ + "img/rubin-img-02.f8216c75.jpg";